import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import ElementPlus from 'element-plus'
import pinia, { initializeStores } from '@/stores'
// import VueVideoPlayer from '@videojs-player/vue'
import 'video.js/dist/video-js.css'

import '@/assets/css/index.scss'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import 'animate.css'

async function bootstrap () {
  const app = createApp(App)

  app.use(router).use(ElementPlus, { size: 'default', locale: zhCn }).use(pinia)

  await initializeStores()

  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }

  app.mount('#app')
}

bootstrap()
